// Port of api/fuel/app/classes/insights/hindex/designer.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'
import Designer from 'offline/model/designer'

export default Segment.extend({
    name: 'designer',
    priority: 1,
    default_: false,
    requires: ['init'],
    insight: false,
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}

        var gamesIndex = this._data.current.get_index_level()

        var collectedIndex = Util.query(
            'SELECT g.game_id FROM' +
            ' (game_designer l JOIN collection c ON c.game_id = l.game_id' +
            ' AND c.collection_own = 1' +
            ' AND c.user_id IN (' + Util.in(userIndex) + ')' +
            ' AND l.designer_id = ' + vars.id + ')' +
            ' JOIN game g ON c.game_id = g.game_id' +
            ' AND g.game_type = 1' +
            ' AND g.game_id IN (' + Util.in(gamesIndex) + ')' +
            ' GROUP BY g.game_id' +
            ' ORDER BY g.game_name ASC'
        )

        var gameIds = Util.pluck(collectedIndex, 'game_id')
        if (!gameIds.length) gameIds = [0]

        var ratings = Util.query(
            'SELECT COUNT(r.rating_id) AS count, AVG(r.rating_value) AS avg, r.game_id AS game_id' +
            ' FROM rating r' +
            ' WHERE r.game_id IN (' + Util.in(gameIds) + ')' +
            ' AND r.user_id IN (' + Util.in(userIndex) + ')' +
            ' GROUP BY r.game_id',
            null, 'game_id'
        )

        var games = []

        for (var i = 0; i < gameIds.length; i++) {
            var gameId = gameIds[i]
            this._references.games.push(gameId)

            games.push({
                id: parseInt(gameId, 10),
                count: ratings[gameId] ? parseFloat(ratings[gameId].count) : 0,
                rating: ratings[gameId] ? Math.round(parseFloat(ratings[gameId].avg) * 10) / 10 : 0
            })
        }

        var designerModel = Designer.with_id(vars.id)

        return {
            designer: designerModel ? designerModel.get_name() : '',
            games: games
        }

    }
})
